module.exports = __webpack_public_path__ + "img/panel_5.34fde173.png";